<div class="text-container">
  <h2>{{ data?.name }}</h2>
  <p class="lead" [innerHTML]="data?.description"></p>
</div>
